import React, { useState } from "react";
import { Box, Typography, Grid, Divider, SvgIcon } from "@mui/material";
import { ReactComponent as MailIcon } from "../../../assets/icons/mail-lightyellow.svg";
import { ReactComponent as MobileIcon } from "../../../assets/icons/call-lightyellow.svg";
import { ReactComponent as StoreIcon } from "../../../assets/icons/store-icon.svg";
import MapComponent from "../../../common/components/map-component/map-component";
import { generateGoogleMapsDirectionsUrl } from "../../../api/contact-us";
import "./ContactDetailsMap.scss";

export default function ContactDetailsMap() {

  const [showEmergencyPhone, setShowEmergencyPhone] = useState(false);

  // Destination (MemorialGo)
  const destinationLat = 37.346507;
  const destinationLng = -121.924367;

  const handleGetDirections = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLat = position.coords.latitude;
        const userLng = position.coords.longitude;

        const googleMapsUrl = generateGoogleMapsDirectionsUrl(
          userLat,
          userLng,
          destinationLat,
          destinationLng
        );

        window.open(googleMapsUrl, "_blank");
      },
      (error) => {
        console.error("Error getting user location:", error);
        alert("Unable to retrieve your location.");
      }
    );
  };

  return (
    <Box className="contact-details-map">
      <Grid container spacing={2.5}>
        {/* Section 1: Contact Information */}
        <Grid item xs={12} md={6}>
          <Box className="contact-details-map__info">
            <Typography
              variant="h6"
              className="contact-details-map__section-title"
            >
              Contact Information
            </Typography>

            <Divider className="contact-details-map__divider contact-details-map__divider--first" />

            <Grid
              container
              spacing={2}
              rowGap="25px"
              className="contact-details-map__contact-grid"
            >
              {/* Address */}
              <Grid
                item
                xs={12}
                sm={6}
                className="contact-details-map__contact-item"
              >
                <Box className="contact-details-map__icon-text">
                  <SvgIcon
                    component={StoreIcon}
                    inheritViewBox
                    sx={{ mr: 1, fill: "none", fontSize: 32 }}
                    className="contact-details-map__icon"
                  />
                  <Box>
                    <Typography className="contact-details-map__label">
                      Address
                    </Typography>
                    <Typography className="contact-details-map__text">
                      Walhalla, SC 29691, US
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Phone */}
              <Grid
                item
                xs={12}
                sm={6}
                className="contact-details-map__contact-item"
              >
                <Box className="contact-details-map__icon-text">
                  <SvgIcon
                    component={MobileIcon}
                    inheritViewBox
                    sx={{ mr: 1, fill: "none", fontSize: 32 }}
                    className="contact-details-map__icon"
                  />
                  <Box>
                    <Typography className="contact-details-map__label">
                      Phone Number
                    </Typography>
                    <Typography
                      className="contact-details-map__text"
                      component="a"
                      href="tel:4803004719"
                      sx={{
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer",
                      }}
                    >
                      480-300-4719
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Email */}
              <Grid
                item
                xs={12}
                sm={6}
                className="contact-details-map__contact-item"
              >
                <Box className="contact-details-map__icon-text">
                  <SvgIcon
                    component={MailIcon}
                    inheritViewBox
                    sx={{ mr: 1, fill: "none", fontSize: 32 }}
                    className="contact-details-map__icon"
                  />
                  <Box>
                    <Typography className="contact-details-map__label">
                      Email
                    </Typography>
                    <Typography
                      className="contact-details-map__text"
                      component="a"
                      href="mailto:info@afphorizon.com"
                      sx={{
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer",
                      }}
                    >
                      info@afphorizon.com
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Emergency */}

              {
                showEmergencyPhone &&  <Grid
                item
                xs={12}
                sm={6}
                className="contact-details-map__contact-item"
              >
                <Box className="contact-details-map__icon-text">
                  {/* <LocalHospitalIcon className="contact-details-map__icon" /> */}
                  <SvgIcon
                    component={MobileIcon}
                    inheritViewBox
                    sx={{ mr: 1, fill: "none", fontSize: 32 }}
                    className="contact-details-map__icon"
                  />
                  <Box>
                    <Typography className="contact-details-map__label">
                      Emergency Help Line
                    </Typography>
                    <Typography
                      className="contact-details-map__text"
                      component="a"
                      href="tel:4803004719"
                      sx={{
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer",
                      }}
                    >
                      480-300-4719
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              }
              
            </Grid>

            {/* Business Hours */}
            <Typography
              variant="h6"
              className="contact-details-map__section-title-business"
            >
              Business Hours
            </Typography>

            <Divider className="contact-details-map__divider" />

            <Box className="contact-details-map__hours">
              <Typography className="contact-details-map__days-text">
                Monday - Friday
              </Typography>
              <Box sx={{ flex: 1 }} />
              <Typography className="contact-details-map__hours-text">
                9:30 AM - 8:30 PM
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Section 2: Map */}
        <Grid item xs={12} md={6}>
          <Box className="contact-details-map__map-wrapper">
            <Box className="contact-details-map__map-header">
              <Typography className="contact-details-map__map-title">
                Location
              </Typography>
              <Typography
                className="contact-details-map__map-link"
                onClick={handleGetDirections}
              >
                Get Directions
              </Typography>
            </Box>

            <Box className="contact-details-map__map">
              <MapComponent
                latitude={34.777410}
                longitude={-83.069940}
                zoom={16}
                height="340px"
                width="100%"
                borderRadius="10px"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
